export type BdVirtualClinicInsuranceType = 'PRIVATE_HEALTH_INSURANCE' | 'MANDATORY_HEALTH_INSURANCE'

export const BD_VIRTUAL_CLINIC_INSURANCE_TYPE_DISPLAY_NAMES: Record<BdVirtualClinicInsuranceType, string> = {
  PRIVATE_HEALTH_INSURANCE: 'Privat',
  MANDATORY_HEALTH_INSURANCE: 'Gesetzlich',
};
